var exports = {
  "ZW": "x234b8571--2d305e--switch",
  "Kk": "x234b8571--2d305e--icon",
  "vu": "x234b8571--2d305e--active",
};

module.exports = exports;
